module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido2.28918645.svg";